import { render, staticRenderFns } from "./VProjectReportGroup.vue?vue&type=template&id=bb4dcd66&"
import script from "./VProjectReportGroup.vue?vue&type=script&lang=js&"
export * from "./VProjectReportGroup.vue?vue&type=script&lang=js&"
import style0 from "./VProjectReportGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports